<template>
  <div class="wrap">
    <Nav :title="$t('goods.contract')" fixed safeAreaInsetTop placeholder />
    <div class="content">
      <div class="img">
        <img :src="$img(userInfo.loan.contract)" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import { Icon, Toast } from "vant";
import Nav from "@/components/Navbar";
import { GetUserAgreement } from '@/api'
import { mapGetters } from "vuex"
export default {
  components: {
    [Icon.name]: Icon,
    Nav
  },
  data() {
    return {
      agreement:""
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created(){
    // this.getAgreement()
  },
  methods:{
    async getAgreement(){
      try {
        const res = await GetUserAgreement();
        this.agreement  = res.data
      } catch (error) {
        
      }
    }
  }
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background-color: var(--newbg);

  .content {
    padding: calc(20rem / 16);
    .img{
      img{
        width: 100%;
        display: block;
      }
    }
  }
}
</style>